// ProductDetailsPage.jsx
import { useParams, useLocation } from "react-router-dom";

export const ProductDetailsPage = () => {
  const { productId } = useParams();
  const location = useLocation();
  const productName = location.state?.productName || "Product";

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-12">
          <h2>Product Details: {productName} (ID: {productId})</h2>
          {/* Add your product details logic here */}
        </div>
      </div>
    </div>
  );
};